import gql from 'graphql-tag';

export default gql`
  fragment contactNgReasonTemplateFragment on ContactNgReasonTemplate {
    id
    clientId
    reason
  }
`;
